export const ROUTE_PREFIX = "/admin";

export const LOGIN_ROUTE = ROUTE_PREFIX + "/login";

export const FORGOT_PASSWORD_ROUTE = ROUTE_PREFIX + "/forgot-password";

export const EMPTY_ROUTE = ROUTE_PREFIX + "/empty";

export const USER_MANAGEMENT_ROUTE = ROUTE_PREFIX + "/user-management";

export const CUSTOMER_ROUTE = ROUTE_PREFIX + "/customers";

export const UNIT_ROUTE = ROUTE_PREFIX + "/unit";

export const PRODUCT_ATTRIBUTE_GROUP_ROUTE =
  ROUTE_PREFIX + "/product-attribute-group";

export const PRODUCT_ATTRIBUTE_ROUTE = ROUTE_PREFIX + "/product-attribute";

export const PRODUCT_ATTRIBUTE_VALUE_ROUTE =
  ROUTE_PREFIX + "/product-attribute-value";

export const TAG_ROUTE = ROUTE_PREFIX + "/tag";

export const THEME_TEMPLATE_ROUTE = ROUTE_PREFIX + "/theme-template";
export const ADD_THEME_TEMPLATE_ROUTE = THEME_TEMPLATE_ROUTE + "/add";
export const UPDATE_THEME_TEMPLATE_ROUTE = THEME_TEMPLATE_ROUTE + "/update";

export const THEME_SETTING_ROUTE = ROUTE_PREFIX + "/theme-setting";
export const ADD_THEME_SETTING_ROUTE = THEME_SETTING_ROUTE + "/add";
export const UPDATE_THEME_SETTING_ROUTE = THEME_SETTING_ROUTE + "/update";

export const PRODUCT_CATEGORY_ROUTE = ROUTE_PREFIX + "/product-category";
export const ADD_PRODUCT_CATEGORY_ROUTE = PRODUCT_CATEGORY_ROUTE + "/add";
export const UPDATE_PRODUCT_CATEGORY_ROUTE = PRODUCT_CATEGORY_ROUTE + "/update";

export const PRODUCT_COMMENT_ROUTE = ROUTE_PREFIX + "/product-comment";

export const PRODUCT_ROUTE = ROUTE_PREFIX + "/product";
export const ADD_PRODUCT_ROUTE = PRODUCT_ROUTE + "/add";
export const UPDATE_PRODUCT_ROUTE = PRODUCT_ROUTE + "/update";

export const WEBSITE_CONFIG_ROUTE = ROUTE_PREFIX + "/website-config";
export const SYSTEM_CONFIG_ROUTE = ROUTE_PREFIX + "/system-config";
export const FIREBASE_CONFIG_ROUTE = ROUTE_PREFIX + "/firebase-config";
export const TRANSPORTATION_ROUTE = ROUTE_PREFIX + "/transportation";
export const COMMENT_ROUTE = ROUTE_PREFIX + "/comment";

export const BRANCH_ROUTE = ROUTE_PREFIX + "/branch";
export const ADD_BRANCH_ROUTE = BRANCH_ROUTE + "/add";
export const UPDATE_BRANCH_ROUTE = BRANCH_ROUTE + "/update";

export const STAFF_ROUTE = ROUTE_PREFIX + "/staff";

export const PRODUCT_STOCK_ROUTE = ROUTE_PREFIX + "/product-stock";

export const WARE_HOUSE_ROUTE = ROUTE_PREFIX + "/ware-house";
export const ADD_WARE_HOUSE_ROUTE = WARE_HOUSE_ROUTE + "/add";
export const UPDATE_WARE_HOUSE_ROUTE = WARE_HOUSE_ROUTE + "/update";

export const SHIPPING_FEE_DEFAULT_ROUTE =
  ROUTE_PREFIX + "/shipping-fee/default";
export const SHIPPING_FEE_BY_ADDRESS_ROUTE =
  ROUTE_PREFIX + "/shipping-fee/by-address";
export const SHIPPING_FEE_BY_ORDER_AMOUNT_ROUTE =
  ROUTE_PREFIX + "/shipping-fee/by-order-amount";

export const PAYMENT_SETTING_ROUTE = ROUTE_PREFIX + "/payment-setting";

export const ORDER_ROUTE = ROUTE_PREFIX + "/order";
export const ORDER_REPORT_ROUTE = ROUTE_PREFIX + "/order-report";

export const MODIFIER_GROUP_ROUTE = ROUTE_PREFIX + "/modifier_group";

export const PROMOTION_CODE_ROUTE = ROUTE_PREFIX + "/promotion_code";
export const ADD_PROMOTION_CODE_ROUTE = PROMOTION_CODE_ROUTE + "/add";
export const UPDATE_PROMOTION_CODE_ROUTE = PROMOTION_CODE_ROUTE + "/update";

export const UN_AUTH_PATH = [LOGIN_ROUTE, FORGOT_PASSWORD_ROUTE];
